const getCustomerId = () => {
  const location = window.location.hostname;
  if (location === 'localhost') {
    return 'localhost';
  }
  const customerId = location.split('.')[0];
  return customerId;
};

export default getCustomerId;
